var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreCrystal = function SvgStoreCrystal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "m51.003 12.981-8.46-2.445-9.291-2.681-9.29-2.685-8.466-2.446-12.582 10.27 17.614 38.923 35.648-23.545z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#store-crystal_svg__a)",
    stroke: "#000",
    d: "m15.495 2.725 8.466 2.445 9.29 2.685-12.724 44.062L2.913 12.994z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m3.056 12.962 26.56 7.48M20.527 51.917 16.298 16.6 23.96 5.17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#store-crystal_svg__b)",
    stroke: "#000",
    d: "m51.002 12.982-8.46-2.446-9.291-2.68-12.724 44.061 35.648-23.544z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m56.096 28.286-26.48-7.844M20.527 51.917 42.93 24.286l-.389-13.75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.595 27.718c.043-.65.145-3.27-1.723-5.678-2.074-2.672-5.028-3.09-5.592-3.16.71.01 3.313-.033 5.699-1.97 2.471-2.005 3.018-4.669 3.134-5.344-.06.491-.372 3.484 1.808 6.062 2.117 2.497 4.994 2.74 5.503 2.775-.898.085-3.434.449-5.746 2.467a10.3 10.3 0 0 0-3.092 4.848zM35.177 28.885c.021-.325.072-1.633-.86-2.839-1.034-1.334-2.514-1.543-2.796-1.577a4.5 4.5 0 0 0 2.852-.984c1.236-1 1.51-2.334 1.569-2.672-.03.244-.184 1.745.906 3.032 1.056 1.248 2.497 1.372 2.754 1.389a5.14 5.14 0 0 0-2.873 1.231 5.1 5.1 0 0 0-1.544 2.424z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "store-crystal_svg__a",
    x1: 2.913,
    x2: 52.399,
    y1: 7.152,
    y2: 33.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A94F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "store-crystal_svg__b",
    x1: 20.527,
    x2: 70.698,
    y1: 11.821,
    y2: 46.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A94F5"
  })))));
};
export default SvgStoreCrystal;